import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

import ADIPromotionState from "../Data/ADIPromotionState";

const initialState: ADIPromotionState = {
    showPromotionErrorMessage: false,
    promotionErrorMessage: "",
    removedPromoCode: "",
};

const reducer = {
    "Custom/Checkout/ShowPromotionErrorMessage": (
        draft: Draft<ADIPromotionState>,
        action: { showPromotionErrorMessage: boolean; promotionErrorMessage: string; removedPromoCode: string },
    ) => {
        draft.showPromotionErrorMessage = action.showPromotionErrorMessage;
        draft.promotionErrorMessage = action.promotionErrorMessage;
        draft.removedPromoCode = action.removedPromoCode;
    },
    "Custom/Checkout/ShowPromotionErrorMessage/Reset": (draft: Draft<ADIPromotionState>) => {
        draft.showPromotionErrorMessage = false;
        draft.promotionErrorMessage = "";
        draft.removedPromoCode = "";
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
